import logo002 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.002.png';
import logo003 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.003.png';
import logo004 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.004.png';
import logo005 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.005.png';
import logo006 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.006.png';
import logo007 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.007.png';
import logo008 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.008.png';
import logo009 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.009.png';
import logo010 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.010.png';
import logo011 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.011.png';
import logo012 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.012.png';
import logo013 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.013.png';
import logo014 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.014.png';
import logo015 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.015.png';
import logo016 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.016.png';
import logo017 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.017.png';
import logo018 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.018.png';
import logo019 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.019.png';
import logo020 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.020.png';
import logo021 from '../assets/img/Aspose.Words.25344eb0-5c47-4d71-bd16-8bccf52a42a7.021.png';

const logos = [
  logo002,
  logo003,
  logo004,
  logo005,
  logo006,
  logo007,
  logo008,
  logo009,
  logo010,
  logo011,
  logo012,
  logo013,
  logo014,
  logo015,
  logo016,
  logo017,
  logo018,
  logo019,
  logo020,
  logo021
];

const Alliances = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Our Alliances</h1>
          <p>
            Nexus IT collaborates with leading global technology providers to deliver innovative, secure, and scalable
            solutions tailored to every client engagement.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="logo-grid" aria-label="Alliance logos">
            {logos.map((logo) => (
              <img src={logo} alt="Alliance logo" key={logo} />
            ))}
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Harness Global Innovation</h2>
              <p>Through strong alliances, Nexus IT delivers vendor-backed solutions and co-innovates for client success.</p>
            </div>
            <a className="btn btn-primary" href="mailto:info@nexusitpk.com">
              Discuss Partnerships
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Alliances;
